import React, { useState, useEffect } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import "react-calendar/dist/Calendar.css";
import { HTTP } from "../api/http-common";
import { useNavigate,Link } from "react-router-dom";
import '../styling/Events.css'
import Tippy from "@tippyjs/react";
import { ArrowUpRightSquareIcon } from "lucide-react";
function EventCalendar() {
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [pastEvents, setPastEvents] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [showCalendar, setShowCalendar] = useState(false);
  const navigate = useNavigate(); // Use navigate hook for redirection

  const fetchEvents = async () => {
    try {
      const response = await HTTP.post("/user/get_event");
      setUpcomingEvents(response.data.upcoming_events);
      setPastEvents(response.data.past_events);
    } catch (error) {
      console.error("Error fetching events:", error);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  // const handleEventClick = (eventId) => {
  //   navigate(`/events/${eventId}`);

  // };

  // Filter events based on search query
  const filteredUpcomingEvents = upcomingEvents.filter(event =>
    event.title.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const filteredPastEvents = pastEvents.filter(event =>
    event.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const formatTime = (time) => {
    const [hours, minutes] = time.split(":");
    return new Date(0, 0, 0, hours, minutes).toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", hour12: true });
  };

  const [isExpanded, setIsExpanded] = useState(false);
  const maxLength = 200;

  return (
    <>
      {/* Header */}
      {/* Search Bar & Buttons */}
      <div className="flex justify-between items-center bg-white md:px-5 lg:px-10 p-2 md:p-4 event-page-title-wrapper" >
        <h1 className="text-2xl md:text-3xl font-bold ">Family Festivals</h1>

        <input
          type="text"
          placeholder="Search for events"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="border md:p-2 p-1 rounded w-1/3 md:w-1/4"
        />
        {/* <button
          onClick={() => setShowCalendar(!showCalendar)}
          className="bg-gray-200 text-gray-800 px-4 py-2 rounded-md"
        >
          {showCalendar ? "Hide Calendar" : "Show Calendar"}
        </button> */}
      </div>

      <div className="container mx-auto md:px-[20px] px-0">

        {/* FullCalendar View */}
        {showCalendar && (
          <div className="mt-4">
            <FullCalendar
              plugins={[dayGridPlugin]}
              initialView="dayGridMonth"
              events={upcomingEvents.map((event) => ({
                title: event.title,
                start: event.start_date,
                url: `/event/${event.id}`,
              }))}
              eventColor="#007BFF"
              height="auto"
            />
          </div>
        )}
        <div className="events-list-wrapper custom-theme-scroll"  >
          {/* Upcoming Events Section */}
          <div className="mt-6 px-2.5 md:px-0">
            <h2 className="text-xl font-semibold mb-4 px-4 md:px-0" data-aos-delay="200">Upcoming Events</h2>
            {filteredUpcomingEvents.length === 0 ? (
              <p className="text-gray-500 bg-gray-100 p-4 rounded-md text-center">
                No upcoming events found.
              </p>
            ) : (
              filteredUpcomingEvents.map((event) => (
                <div key={event.id} className="flex items-start border py-4 px-6 event-details-wrapper"
                // onClick={() => handleEventClick(event.id)}
                data-aos-delay={event.id*100}
                >
                  {/* Date Section */}
                  <div className="text-center mr-4 event-date-wrapper">
                    <div className="text-xl font-bold text-gray-900">
                      {event.start_date_formatted_month}
                    </div>
                    <div className="text-3xl font-bold theme-color">
                      {event.start_date_formatted_date}
                    </div>
                    <div className="text-gray-500">
                      {event.start_date_formatted_year}
                    </div>
                  </div>

                  {/* Event Details */}
                  <div className="flex-1 px-[10px] md:px-0">
                    <p className="text-gray-700 text-sm event-time-detail">
                      {/* {new Date(event.end_date).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })} @ {formatTime(event.start_time)} - {formatTime(event.end_time)} */}
                      {/* {new Date(event.start_date).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })} @  */}
                      <span className="theme-color"> {formatTime(event.start_time)} </span>  -  <span className="theme-color"> {formatTime(event.end_time)}</span>
                    </p>
                    <Link to={`/events/${event.id}`}>
                      <h3 className="event-calender-title">{event.title}</h3>
                    </Link>
                    <p className="text-gray-600">
                      <strong>{event.address}</strong>, {event.city_name}, {event.state}
                    </p>
                    <p className="text-gray-500">
                      {isExpanded
                        ? event.description
                        : `${event.description.slice(0, maxLength)}...`}

                      {event.description.length > maxLength && (


                        <button
                          onClick={(e) => {
                            e.stopPropagation(); // Prevent parent click event
                            navigate(`/events/${event.id}`); // Redirect to event details page
                          }}
                          className="text-blue-500 mt-2 underline cursor-pointer cursor-pointer"
                        >
                          Read More

                        </button>

                      )}
                    </p>
                  </div>
                  {event.image && (
                    <div onClick={(e) => {e.stopPropagation(); navigate(`/events/${event.id}`); }} className="cursor-pointer event-detail-image ml-4">
                      <div className="event-detail-page-thumbnail-image">
                      <img src={event.image} alt={event.title} className="w-full h-full object-cover rounded-md " />
                      </div>
                    </div>
                  )}
                </div>
              ))
            )}
          </div>

          {/* Past Events Section */}
          {/* <div className="mt-10 px-2.5 "> */}
          <div className="mt-10 ">
            <h2 className="text-xl font-semibold mb-4 px-4 md:px-0">Past Events</h2>
            {filteredPastEvents.length === 0 ? (
              <p className="text-gray-500 bg-gray-100 p-4 rounded-md text-center">
                No past events found.
              </p>
            ) : (
              filteredPastEvents.map((event) => (
                <div key={event.id} className="flex items-start border py-4 px-6 event-details-wrapper"
                // onClick={() => handleEventClick(event.id)}
                >
                  {/* Date Section */}
                  <div className="text-center mr-4 event-date-wrapper">
                    <div className="text-xl font-bold text-gray-900">
                      {new Date(event.start_date).toLocaleString("en-US", { month: "short" })}
                    </div>
                    <div className="text-3xl font-bold theme-color">
                      {new Date(event.start_date).getDate()}
                    </div>
                    <div className="text-gray-500">
                      {new Date(event.start_date).getFullYear()}
                    </div>
                  </div>

                  {/* Event Details */}
                  <div className="flex-1 px-[10px] md:px-0">
                    <p className="text-gray-700 text-sm event-time-detail">
                      {/* {new Date(event.end_date).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })} @ {formatTime(event.start_time)} - {formatTime(event.end_time)} */}
                      {/* {new Date(event.start_date).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })} @   */}
                      <span className="theme-color">{formatTime(event.start_time)}  </span> - <span className="theme-color"> {formatTime(event.end_time)}</span> 

                    </p>
                    <Link to={`/events/${event.id}`}>
                      <h3 className="event-calender-title">{event.title}</h3>
                    </Link>
                    <div className="event-calender-description-container">
                    <p className="text-gray-600">
                      <strong>{event.address}</strong>, {event.city_name}, {event.state}
                    </p>
                    <p className="text-gray-500 event-calender-description">
                      {isExpanded
                        ? event.description
                        : `${event.description.slice(0, maxLength)}...`}

                      {event.description.length > maxLength && (
                        <button
                          onClick={(e) => {
                            e.stopPropagation(); // Prevent parent click event
                            navigate(`/events/${event.id}`); // Redirect to event details page
                          }}
                          className="text-blue-500 mt-2 underline cursor-pointer"
                        >
                          Read More
                        </button>
                      )}
                    </p>
                    </div>

                  </div>
                  {event.image && (
                    <div onClick={(e) => {e.stopPropagation(); navigate(`/events/${event.id}`); }} className="cursor-pointer event-detail-image ml-4">
                      <div className="event-detail-page-thumbnail-image">
                      <img src={event.image} alt={event.title} className="w-full h-full object-cover rounded-md " />
                      </div>
                    </div>
                  )}
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default EventCalendar
